// extracted by mini-css-extract-plugin
export default {"name":"q7Mv1Py5"};